import * as React from 'react';

const SVGImprint: React.SFC<SvgProps> = props => (
  <svg width={16} height={20} {...props}>
    <g strokeWidth={1.2} stroke="#B0BDC0" fill="none" fillRule="evenodd">
      <path
        d="M12.683 19.323H3.337a2.086 2.086 0 0 1-2.077-2.094V3.618c0-1.157.93-2.094 2.077-2.094h7.269l4.154 4.188v11.517c0 1.156-.93 2.094-2.077 2.094z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15 6.05l-3.877.065c-.535 0-.97-.488-.97-1.09V1.539" />
      <path d="M4.635 10.423h7.269M4.635 14.611h7.269" strokeLinecap="round" />
    </g>
  </svg>
);

export default SVGImprint;
